import { FC } from "react"
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card"
import { Label } from "./ui/label"
import { Input } from "./ui/input"
interface CustomerInformationFormProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any
}

const CustomerInformationForm: FC<CustomerInformationFormProps> = ({ form }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Customer Information</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <form.Field
            name="name"
            validators={{
              onChange: ({ value }: { value: string }) => (!value ? "Name is required" : undefined),
            }}
          >
            {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
            {(field: any) => (
              <div className="space-y-2">
                <Label htmlFor="name">Full Name *</Label>
                <Input
                  id="name"
                  placeholder="Enter customer full name"
                  value={field.state.value}
                  onBlur={field.handleBlur}
                  onChange={(e) => field.handleChange(e.target.value)}
                />
                {field.state.meta.isTouched && field.state.meta.errors[0] ? (
                  <p className="text-red-500 text-sm">{field.state.meta.errors[0]}</p>
                ) : null}
              </div>
            )}
          </form.Field>

          <form.Field
            name="email"
            validators={{
              onChange: ({ value }: { value: string }) =>
                !value ? "Email is required" : undefined,
            }}
          >
            {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
            {(field: any) => (
              <div className="space-y-2">
                <Label htmlFor="email">Email Address *</Label>
                <Input
                  id="email"
                  type="email"
                  placeholder="customer@example.com"
                  value={field.state.value}
                  onBlur={field.handleBlur}
                  onChange={(e) => field.handleChange(e.target.value)}
                />
                {field.state.meta.isTouched && field.state.meta.errors[0] ? (
                  <p className="text-red-500 text-sm">{field.state.meta.errors[0]}</p>
                ) : null}
              </div>
            )}
          </form.Field>

          <form.Field
            name="address"
            validators={{
              onChange: ({ value }: { value: string }) =>
                !value ? "Address is required" : undefined,
            }}
          >
            {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
            {(field: any) => (
              <div className="space-y-2 md:col-span-2">
                <Label htmlFor="address">Physical Address *</Label>
                <Input
                  id="address"
                  placeholder="Enter full address"
                  value={field.state.value}
                  onBlur={field.handleBlur}
                  onChange={(e) => field.handleChange(e.target.value)}
                />
                {field.state.meta.isTouched && field.state.meta.errors[0] ? (
                  <p className="text-red-500 text-sm">{field.state.meta.errors[0]}</p>
                ) : null}
              </div>
            )}
          </form.Field>
        </div>
      </CardContent>
    </Card>
  )
}

export default CustomerInformationForm
